<template>
  <div>
    <preview-security :item="item" @success="$emit('success', $event)" />
  </div>
</template>

<script>
import PreviewSecurity from '@/views/verification/Components/PreviewSecurity.vue'

export default {
  name: 'CheckPreviewSecurity',
  components: { PreviewSecurity },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$set(this.item, 'loading', true)
      this.$http.get(`/check/detailSecurity/${this.item.id}`).then(response => {
        const data = response.data
        this.item.data = data
        this.$set(this.item, 'loading', false)
      }).catch(() => {
        this.$set(this.item, 'loading', false)
      })
    }
  }
}
</script>

<style scoped>

</style>
